import { Grid } from "@mui/material";
import { titleCase } from "change-case-all";

import FormOne from "./FormOne";
import {
  ButtonFooter,
  PageHeader,
  Paper,
  FloatingEditActionButtons,
} from "../../../components";
import EditButtons from "../../../components/EditButtons";
import FormTwo from "./FormTwo";

export default function FormDisplay({ editState, formikProps, setEditState }) {
  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <PageHeader
          pageName={"Agency Details"}
          pageHeader={
            !formikProps.values.brandID
              ? "Let's add agency information"
              : titleCase(formikProps.values.brandName)
          }
          buttons={[
            <EditButtons editState={editState} setEditState={setEditState} />,
          ]}
        />
      </Grid>

      <Grid size={12}>
        <Paper gridSpacing={4}>
          <FormOne formikProps={formikProps} editState={editState} />
          <FormTwo formikProps={formikProps} editState={editState} />
        </Paper>

        {editState && (
          <Grid size={12}>
            <ButtonFooter
              ID={formikProps.values.brandID}
              editState={editState}
              setEditState={setEditState}
              formikProps={formikProps}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
